<template>
  <div class="login">
    <NavbarItem />
    <div class="container">
      <div class="row mt-5">
        <div class="col">
          <nav aria-label="breadcrumb" style="margin-top: 100px">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Login</li>
            </ol>
          </nav>
        </div>
      </div>

      <div class="row justify-content-center mt-4">
        <div class="col-12">
          <h2 class="mb-4">Login</h2>
          <form @submit.prevent="onSubmit">
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                id="email"
                v-model="email"
                type="email"
                class="form-control"
                placeholder="nama@email.com"
                required
              />
            </div>
            <div class="mb-3">
              <label for="password" class="form-label">Password</label>
              <input
                id="password"
                v-model="password"
                type="password"
                class="form-control"
                placeholder="Password"
                required
              />
            </div>
            <button type="submit" class="btn btn-primary w-100">Login</button>
          </form>
          <p class="mt-4 text-center">
            Belum punya akun?
            <router-link to="/register">Daftar</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarItem from "@/components/Navbar.vue";

export default {
  name: "LoginView",
  components: {
    NavbarItem,
  },
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    onSubmit() {
      // Sementara: bisa diganti dengan pemanggilan API auth
      console.log("Login attempt:", { email: this.email });
      alert("Login (belum terhubung backend). Email: " + this.email);
    },
  },
};
</script>

<style scoped></style>
